import { Box } from '../widgets/Box';

export const Divider = () => (
  <Box width="1px" bgColor="#aaa" m="0 6px" h="4rem"></Box>
);